import React, { useEffect, useState } from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const IncomeListDetails = () => {
  const [incomes, setIncomes] = useState([]);

  useEffect(() => {
    const fetchIncomes = async () => {
      try {
        const url = `${API_DOMAIN}${API_ROUTES.income}`;
        const token = localStorage.getItem('token');
        
        const response = await axios.get(url, { headers });

        setIncomes(response.data);
      } catch (error) {
        console.error('Error fetching incomes:', error);
      }
    };

    fetchIncomes();
  }, []);

  const columns = [
    { label: 'Date', value: 'date' },
    { label: 'Source', value: 'source' },
    { label: 'Amount', value: 'amount' },
    { label: 'Description', value: 'description' },
    { label: 'Income Type', value: 'income_type' },
  ];

  const handleViewDetails = (incomeId) => {
    //console.log('View Details', incomeId);
    const encodedId = btoa(incomeId);
    window.location.href = `/income/details/${encodedId}`;
  };

  const actionButtons = [
    { label: 'View Details', handler: handleViewDetails },
  ];

  return <ListTemplate columns={columns} data={incomes} actionButtons={actionButtons} />;
};

export default IncomeListDetails;